export const sysFirstEnjoy = {
  // 先享后付模块
  checkFirstEnjoyMemberCard: ['/lt-web/xs/member/prepay/cardCheck'], // false: 会员卡是基础类型，会员卡放款后实时扣款，用户无在贷
  getFirstEnjoyPageData: ['/lt-web/member/prepay/signModel'], // 先享后付页面获取数据：优惠券、协议
  getFirstEnjoySendSms: ['/lt-web/member/prepay/sign/apply'], // 先享后付页面发送验证码
  onFirstEnjoySmsSubmit: ['/lt-web/member/prepay/sign/confirm'], // 先享后付页面绑卡校验
  onFirstEnjoyCancel: ['/lt-web/member/prepay/sign/cancal'], // 先享后付绑卡取消
  getIncellConfig: ['/lt-web/rights/sellInTime'] // 限时售卖权益
}

export const advFirstEnjoy = {
  getBorrowApplyPageData: ['/lt-web/xs/adv/benefit/getInfo'], // 先享后付页面获取数据：开关、名称价格、营销图、协议
  getOrderList: ['/lt-web/xs/adv/benefit/orderList'], // 获取智选借款权益模式下的订单信息
  getOrderBenefitUrl: ['/lt-web/xs/adv/benefit/getBenefitUrl'] // 获取行权链接

}
